import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['viewed', 'dialog'];

  dialogTargetConnected() {
    if (this.viewedTarget.dataset.value === 'false') {
      this.openModal();
    }
  }

  openModal(event) {
    this.dialogTarget.isOpen = true;
    this.viewedTarget.dataset.value = true;
    if (event) {
      event.preventDefault();
    }
  }
}
